import { NotificationType } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { getNotifications } from './OperationsNotificationService'

export enum TabOptions {
  all = 0,
  mentions = 1,
  assignedToMe = 2,
  unread = 3,
}

export type NotificationProps = Awaited<ReturnType<typeof getNotifications>>[0]

export enum NotificationCategory {
  mention = 'mention',
  case = 'case',
  other = 'other',
}

const MENTION_TYPES: NotificationType[] = [
  NotificationType.userTaggedInComment,
  NotificationType.userTaggedInExpenseComment,
]

const CASE_TYPES: NotificationType[] = [
  NotificationType.urgentCaseCreated,
  NotificationType.caseAssignedToVendor,
  NotificationType.caseAssignedToMtVendor,
  NotificationType.isgiIssueCreated,
  NotificationType.tripIssueCaseCreated,
]

export const getNotificationCategory = (type: NotificationType): NotificationCategory => {
  if (MENTION_TYPES.includes(type)) return NotificationCategory.mention
  if (CASE_TYPES.includes(type)) return NotificationCategory.case
  return NotificationCategory.other
}
